import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { STORAGE_KEYS } from '../../utils/constants/storage-keys';
import { CustomerSummary } from '../../api-client';
import { sessionStorageHelper } from '../../utils/storage-helpers/session-storage-helper';

// Define a type for the slice state
interface CustomerState extends CustomerSummary { }

// Define the initial state using that type
const initialState: CustomerState = {}

export const customerSlice = createSlice({
    name: 'customer',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        initCustomer: (state, action: PayloadAction<CustomerSummary>) => {
            Object.assign(state, action.payload);

            sessionStorageHelper.setStorageItem(STORAGE_KEYS.BV_CUSTOMER_SUMMARY, action.payload);
        }
    }
});

export const { initCustomer } = customerSlice.actions;

export default customerSlice.reducer;